__turbopack_context__.v({
  "contentWrapper": "LEvA4G_contentWrapper",
  "contentWrapperEn": "LEvA4G_contentWrapperEn",
  "rowTitle": "LEvA4G_rowTitle",
});
